import { getIsCheckedProducts } from 'common/helpers/get-is-checked-products.helper';
import { TState } from 'pages/dimensions/store/dimensions';
import { TBasketItem } from '../types/basket-item.type';

export const getComplimentaryProductInfoForBasket = (dimensions: TState): TBasketItem[] => {
  if (dimensions.checkedProducts.length) {
    return dimensions.complimentaryProductInfo
      .map(item => {
        const isCheckedProduct = getIsCheckedProducts({
          checkedProducts: dimensions.checkedProducts,
          productId: item.productId,
        });
        return isCheckedProduct && item.total.requiredQuantity > 0
          ? {
              code: item.productId,
              quantity: item.total.requiredQuantity,
            }
          : null;
      })
      .filter(item => item !== null) as TBasketItem[];
  }
  return [];
};
